import firebase from "firebase";

import "firebase/auth";
import io from "socket.io-client";
const config = {
  apiKey: "AIzaSyB9xqBFrwuuEdmSA-Kz6R9DDgHM2W5Rbn0",
  authDomain: "aravind-college-project.firebaseapp.com",
  projectId: "aravind-college-project",
  storageBucket: "aravind-college-project.firebasestorage.app",
  messagingSenderId: "995812236386",
  appId: "1:995812236386:web:efc17b5b9b46ad0b8e853b",
};
firebase.initializeApp(config);
export const storage = firebase.storage;
export const auth = firebase.auth;
export const db = firebase.database;
